/**
 * Sync header "Saved (n)" with Wishlist King / Swish drawer items.
 * Counts each product once — no optimistic double-increment.
 * Also: open/close Saved drawer safely without blocking WK add-to-wishlist.
 */
(function () {
  var syncTimer = null;
  var clickLockUntil = 0;

  function countFromStorage() {
    try {
      var saved = localStorage.getItem('casasola_saved_count');
      if (saved !== null && saved !== '') {
        var n = parseInt(saved, 10);
        if (!isNaN(n)) return n;
      }
      for (var i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i);
        if (!key) continue;
        var lk = key.toLowerCase();
        if (lk.indexOf('wishlist') !== -1 || lk.indexOf('swish') !== -1 || lk.indexOf('wk') !== -1) {
          var raw = localStorage.getItem(key);
          if (!raw) continue;
          try {
            var parsed = JSON.parse(raw);
            if (Array.isArray(parsed)) return parsed.length;
            if (parsed && Array.isArray(parsed.items)) return parsed.items.length;
            if (parsed && Array.isArray(parsed.products)) return parsed.products.length;
            if (parsed && typeof parsed.numItems === 'number') return parsed.numItems;
            if (parsed && parsed.wishlist && typeof parsed.wishlist.numItems === 'number') return parsed.wishlist.numItems;
          } catch (e) {}
        }
      }
    } catch (e) {}
    return null;
  }

  var initCount = countFromStorage();
  var lastKnownCount = initCount !== null ? initCount : 0;

  function scheduleSync(delay) {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(function () {
      syncSavedCount();
    }, delay || 0);
  }

  function queryAllDeep(root, selector) {
    var results = [];
    if (!root) return results;

    try {
      results = results.concat(Array.prototype.slice.call(root.querySelectorAll(selector)));
    } catch (e) {}

    var all = [];
    try {
      all = Array.prototype.slice.call(root.querySelectorAll('*'));
    } catch (e) {}

    all.forEach(function (el) {
      if (el.shadowRoot) {
        results = results.concat(queryAllDeep(el.shadowRoot, selector));
      }
    });

    return results;
  }

  function dedupeNested(nodes) {
    return nodes.filter(function (el, index, arr) {
      if (arr.indexOf(el) !== index) return false;
      return !arr.some(function (other) {
        return other !== el && other.contains && other.contains(el);
      });
    });
  }

  function getWishlistDrawer() {
    return document.getElementById('offcanvasWishlistDrawer');
  }

  function getWishlistPage() {
    var drawer = getWishlistDrawer();
    if (drawer) {
      var inDrawer = drawer.querySelector('wishlist-page');
      if (inDrawer) return inDrawer;
    }
    return document.querySelector('wishlist-page');
  }

  function countFromWishlistPage() {
    var page = getWishlistPage();
    if (!page) return null;

    var cards = dedupeNested(queryAllDeep(page, 'wishlist-product-card'));
    if (cards.length) return cards.length;

    cards = dedupeNested(queryAllDeep(page, '.wk-product-card'));
    if (cards.length) return cards.length;

    var idNodes = dedupeNested(
      queryAllDeep(page, '[data-wk-product-id], [data-product-handle]')
    );
    if (idNodes.length) {
      var ids = {};
      var unique = 0;
      idNodes.forEach(function (el) {
        var id =
          el.getAttribute('data-wk-product-id') ||
          el.getAttribute('data-product-handle') ||
          el.getAttribute('data-product-id');
        if (!id || ids[id]) return;
        ids[id] = true;
        unique += 1;
      });
      if (unique) return unique;
    }

    var empty = queryAllDeep(
      page,
      '.wk-wishlist-empty-callout, .wk-empty-callout, .wk-empty, [class*="wishlist-empty"]'
    );
    var visibleEmpty = empty.some(function (el) {
      if (!el || !el.getBoundingClientRect) return false;
      var style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
        return false;
      }
      var rect = el.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    });
    if (visibleEmpty) return 0;

    return null;
  }

  function countFromApp() {
    try {
      var candidates = [
        window.__SWISH__,
        window.Swish,
        window.WishlistKing,
        window.wishlistKing,
        window.WK,
        window.wishlistApp
      ];
      for (var i = 0; i < candidates.length; i++) {
        var app = candidates[i];
        if (!app) continue;
        if (app.wishlist && typeof app.wishlist.numItems === 'number') {
          return app.wishlist.numItems;
        }
        if (app.state && app.state.wishlist) {
          var w = app.state.wishlist;
          if (typeof w.numItems === 'number') return w.numItems;
          if (Array.isArray(w.items)) return w.items.length;
          if (Array.isArray(w.products)) return w.products.length;
        }
      }
    } catch (e) {}
    return null;
  }

  function getCount() {
    var fromPage = countFromWishlistPage();
    if (fromPage !== null) return fromPage;

    var fromApp = countFromApp();
    if (fromApp !== null) return fromApp;

    var fromSt = countFromStorage();
    if (fromSt !== null) return fromSt;

    return lastKnownCount;
  }

  function applyCount(count) {
    lastKnownCount = Math.max(0, Number(count) || 0);
    try {
      localStorage.setItem('casasola_saved_count', String(lastKnownCount));
      document.cookie = 'casasola_saved_count=' + lastKnownCount + '; path=/; max-age=31536000; SameSite=Lax';
    } catch (e) {}
    document.querySelectorAll('.wishlist-header-link .header-saved').forEach(function (btn) {
      var counter = btn.querySelector('.saved-count');
      if (!counter) {
        counter = document.createElement('span');
        counter.className = 'saved-count';
        counter.setAttribute('aria-hidden', 'true');
        var menu = btn.querySelector('.saved-navmenu') || btn;
        menu.appendChild(counter);
      }
      counter.textContent = String(lastKnownCount);
      counter.setAttribute('data-count', String(lastKnownCount));
      if (lastKnownCount > 0) {
        btn.classList.add('is-saved');
      } else {
        btn.classList.remove('is-saved');
      }
    });
  }

  function syncSavedCount() {
    applyCount(getCount());
  }

  function getOffcanvasInstance(drawer) {
    if (!drawer || !window.bootstrap || !bootstrap.Offcanvas) return null;
    return bootstrap.Offcanvas.getOrCreateInstance(drawer);
  }

  function refreshWishlistPage() {
    var page = getWishlistPage();
    if (!page) return;
    try {
      if (typeof page.refresh === 'function') page.refresh();
      else if (typeof page.reload === 'function') page.reload();
      else if (typeof page.update === 'function') page.update();
      else {
        // Force WK custom element to re-render when drawer opens
        page.dispatchEvent(new CustomEvent('wishlist:refresh', { bubbles: true }));
        var html = page.innerHTML;
        page.innerHTML = html;
      }
    } catch (e) {}
  }

  function openSavedDrawer(event) {
    // Never intercept PDP / collection wishlist add buttons
    if (
      event.target.closest(
        'wishlist-button-block, wishlist-button-product, wishlist-button-collection, .product-save-item'
      )
    ) {
      return;
    }

    var link = event.target.closest(
      '.wishlist-header-link .header-saved, a.mobile-menu-saved, a.empty-cart-wishlist'
    );
    if (!link) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var drawer = getWishlistDrawer();
    var instance = getOffcanvasInstance(drawer);
    if (!instance) return;
    instance.show();
    scheduleSync(150);
    scheduleSync(500);
    scheduleSync(1200);
  }

  function closeSavedDrawer(event) {
    var closeBtn = event.target.closest(
      '#offcanvasWishlistDrawer [data-bs-dismiss="offcanvas"], #offcanvasWishlistDrawer .btn-close'
    );
    if (!closeBtn) return;

    var drawer = getWishlistDrawer();
    var instance = getOffcanvasInstance(drawer);
    if (!instance) return;

    // Ensure close always works even if WK / other listeners interfere
    event.preventDefault();
    event.stopPropagation();
    instance.hide();
  }

  function onWishlistInteraction(event) {
    var host = event.target.closest(
      'wishlist-button-block, wishlist-button-product, wishlist-button-collection, .product-save-item'
    );
    if (!host) return;

    // Do not block WK's add/remove — only sync count after
    var now = Date.now();
    if (now < clickLockUntil) return;
    clickLockUntil = now + 400;

    scheduleSync(300);
    scheduleSync(800);
    scheduleSync(1600);
  }

  function onDrawerShown() {
    refreshWishlistPage();
    scheduleSync(100);
    scheduleSync(600);
  }

  function onDrawerHidden() {
    scheduleSync(100);
  }

  function checkProductSaveItem() {
    document.querySelectorAll('.product-save-item').forEach(function (el) {
      if (el.querySelector('.wk-button')) {
        el.classList.add('has-wk-button');
      }
    });
  }

  function onPlaceholderClick(event) {
    var placeholder = event.target.closest('.product-save-item-placeholder');
    if (!placeholder) return;

    event.preventDefault();
    event.stopPropagation();

    var saveItem = placeholder.closest('.product-save-item');
    var realBtn = saveItem ? saveItem.querySelector('.wk-button') : null;
    if (realBtn) {
      realBtn.click();
      return;
    }

    if (saveItem && window.MutationObserver) {
      var obs = new MutationObserver(function () {
        var b = saveItem.querySelector('.wk-button');
        if (b) {
          obs.disconnect();
          saveItem.classList.add('has-wk-button');
          b.click();
        }
      });
      obs.observe(saveItem, { childList: true, subtree: true });
      window.setTimeout(function () {
        obs.disconnect();
      }, 8000);
    }
  }

  document.addEventListener('click', openSavedDrawer, true);
  document.addEventListener('click', closeSavedDrawer, true);
  document.addEventListener('click', onWishlistInteraction, false);
  document.addEventListener('click', onPlaceholderClick, true);

  ['wk:item:add', 'wk:item:remove', 'wk:wishlist:updated', 'wishlist:updated', 'wishlist:refresh', 'wk:ready'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      scheduleSync(50);
      scheduleSync(400);
    });
    window.addEventListener(evt, function () {
      scheduleSync(50);
      scheduleSync(400);
    });
  });

  function boot() {
    checkProductSaveItem();
    syncSavedCount();
    scheduleSync(300);
    scheduleSync(1000);

    var drawer = getWishlistDrawer();
    if (drawer) {
      drawer.addEventListener('shown.bs.offcanvas', onDrawerShown);
      drawer.addEventListener('hidden.bs.offcanvas', onDrawerHidden);
    }

    var page = getWishlistPage();
    if (page && window.MutationObserver) {
      var moTimer = null;
      new MutationObserver(function () {
        window.clearTimeout(moTimer);
        moTimer = window.setTimeout(function () {
          scheduleSync(0);
        }, 120);
      }).observe(page, {
        childList: true,
        subtree: true
      });
    }

    if (window.MutationObserver) {
      new MutationObserver(function () {
        checkProductSaveItem();
      }).observe(document.body || document.documentElement, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.casasolaSyncSavedCount = syncSavedCount;
})();
